import { CHANNEL } from '../constants/messageTemplateKeys';
import { plainTextToHtml } from './plainTextToHtml';
import { extractCustomStyle, extractEditorContent } from './stripTemplateContent';

export function buildPreviewTemplate(item, logoUrl, senderInfo) {
  const isEmail = (item.channel ?? CHANNEL.EMAIL) === CHANNEL.EMAIL;
  const htmlContent = isEmail
    ? extractEditorContent(item.html_content)
    : plainTextToHtml(item.text_content);

  return {
    name: item.name ?? '',
    channel: item.channel ?? CHANNEL.EMAIL,
    subjects: (item.subjects ?? []).map((s) => (typeof s === 'string' ? s : (s.text ?? ''))),
    htmlContent,
    // Responsive/custom CSS (e.g. @media from migrated MJML) so the preview iframe renders
    // multi-column layouts the same way the saved email does, instead of collapsing them.
    customStyle: isEmail ? extractCustomStyle(item.html_content) : '',
    disclosures: (item.disclosures ?? []).map((d) => ({ name: d.name ?? '' })),
    logoUrl: logoUrl ?? null,
    senderInfo: senderInfo ?? null,
  };
}
